<div class="space-y-md" *transloco="let t">
  <h3 class="heading-lg">
    {{ t('proDirectoryPage.sideNav.top10OfferingsTitle') }}
  </h3>
  <ul class="space-y-xs">
    @for (o of offerings; track o) {
      <li>
        <a
          [routerLink]="
            linkService.localizedPathTo(APPLICATION_ROUTES.OFFERING_PAGE, {routeParams: {pageSlug: o.slug ?? o.id}})
          "
        >
          <cft-chip [colour]="'president-light'" [text]="o.label"></cft-chip>
        </a>
      </li>
    }
  </ul>
</div>
